"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get BaseResourceChangeType () {
        return BaseResourceChangeType;
    },
    get BaseResourceLog () {
        return BaseResourceLog;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _base = require("../base");
const BaseResourceChangeType = _zod.z.union([
    _zod.z.literal("create"),
    _zod.z.literal("update"),
    _zod.z.literal("delete")
]);
const BaseResourceLog = _base.BaseDocument.extend({
    resource_id: _zod.z.instanceof(_bson.ObjectId),
    changed_by: _zod.z.instanceof(_bson.ObjectId).nullable(),
    changed_at: _zod.z.date(),
    // Overridden by resource specific types
    resource_type: _zod.z.string(),
    change_type: _zod.z.string(),
    data: _zod.z.record(_zod.z.string(), _zod.z.unknown())
});
